<template>
  <div>
    <el-card>
      <div style="margin-bottom: 20px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handelAdd"
          >添加</el-button
        >
        <el-button
          type="warning"
          size="mini"
          @click="handelShowCustomer"
          >联系客服</el-button
        >
      </div>
      <el-table stripe border :data="list">
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column label="Banner图" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.img"
              style="width: 300px; height: 200px"
              :preview-src-list="[scope.row.img]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="handelEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
          :current-page="page"
          :page-sizes="[5, 10, 20, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handelSizeChange"
          @current-change="handelPage"
        >
        </el-pagination> -->
    </el-card>
    <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="Banner图片">
          <uploadImg :limit="1" v-model="form.img"></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 编辑悬浮框 -->
    <el-dialog title="联系客服" :visible.sync="showCustomer" width="600px" :close-on-click-modal="false">
      <el-form :model="customerForm" label-width="100px">
        <el-form-item label="微信">
          <el-input type="text" v-model="customerForm.name" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input type="text" v-model="customerForm.phone" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="二维码">
          <uploadImg :limit="1" v-model="customerForm.img"></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showCustomer = false">取 消</el-button>
        <el-button type="primary" @click="handelSaveCustomer">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBannerList,
  saveBanner,
  getCustomerList,
  saveCustomer,
} from "@/api";
import uploadImg from "@/components/upload-img/index.vue";
export default {
  name: "Banner",
  components: {
    uploadImg,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogFormVisible: false,
      type: 1, //1添加 2编辑
      form: {},
      showCustomer: false,
      customerForm: {
        name: "",
        id: "",
      },
    };
  },
  mounted() {
    this.handleGetClassList();
  },
  methods: {
    handelShowCustomer() {
      getCustomerList().then((res) => {
        if (res.code == 200) {
          this.customerForm = res.data;
          this.showCustomer = true;
        }
      });

    },
    handelSaveCustomer(){
       let formData = new FormData();
       formData.append("name", this.customerForm.name);
       formData.append("phone", this.customerForm.phone);
       formData.append("img", this.customerForm.img);
       formData.append("id", this.customerForm.id);
       saveCustomer(formData).then((res) => {
         if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
          this.showCustomer = false;
        }
       });
    },
    submit() {
      if (!this.form.img) {
        this.$message.error("Banner图片不能为空");
        return;
      }
      let formData = new FormData();
      formData.append("img", this.form.img);
      formData.append("id", this.form.id);
      saveBanner(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogFormVisible = false;
          this.handleGetClassList();
        }
      });
    },
    handelEdit({ id, img }) {
      this.form = { id, img };
      this.dialogFormVisible = true;
    },
    handelAdd() {
      this.form = {};
      this.type = 1;
      this.dialogFormVisible = true;
    },
    handleDelClass({ id, title }) {
      this.$confirm(`此操作将永久删除该分类【${title}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          delClass(formData).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleGetClassList();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleGetClassList() {
      getBannerList().then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    handelPage(val) {
      this.page = val;
      this.handleGetClassList();
    },
    handelSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleGetClassList();
    },
  },
};
</script>

<style></style>
